/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import Pollly from "./Dashboard/Pollly";

const FeatureRequests = () => {
  return (
    <div className="feature-requests">
      <Pollly />
    </div>
  );
};
export default FeatureRequests;
